const win = /** @type {import('./lib/pd-window.js').PDWindow} */ (window);

/**
 * @type {{[key: string]: string}}
 */
const langSelectorMap = {
  "fr" : "https://www.pagerduty.com/fr/",
  "de" : "https://www.pagerduty.com/de/",
  "ja" : "https://www.pagerduty.co.jp/",
}
export function initLangSelector() {
  const selectElm = document.querySelector('#footer-lang-select > select');
  if (!(selectElm instanceof HTMLSelectElement)) return;
  selectElm.onchange = function (/* evt */) {
    const code = selectElm.value;
    const alternate = langSelectorMap[code];
    
    const dest = [
      alternate,
      location.search,
      location.hash
    ].join('');

    const goToDest = () => location.href = dest;

    if (win.analytics && typeof win.analytics.track === 'function') {
      /** @type {HTMLOptionElement | null} */
      const optionElm = selectElm.querySelector('[value='+ code +']');
      const properties = {
        event_type: 'select-language',
        event_properties: [code, dest],
        text: (optionElm && optionElm.textContent) || '',
        language: code,
        destination: dest
      };
      win.analytics.track('Generic Event', properties, goToDest);
    }
    // Unconditionally run the callback as `win.analytics.track` may be stubbed
    goToDest();
  }
}
